export default "__VITE_ASSET__D8OU9jN1__"